var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select2',{attrs:{"id":_vm.id,"options":_vm.options,"value":_vm.value,"required":_vm.required,"disabled":_vm.disabled,"settings":_vm.comboSettings},on:{"change":_vm.update}})
}
var staticRenderFns = []

export { render, staticRenderFns }